import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import styles from "./SummaryValue.module.css";

export default function SummaryValue(props) {
    const answerLabel = typeof props.value === "object" ? props.value.label : props.label;
    const answerValue = typeof props.value === "object" ? props.value.value : props.value;
    const { xs, sm, md, lg, xl } = props.sizes;

    const showRequiredInLabel = (label) => {
        return <Typography variant="subtitle2" gutterBottom>
            {props.required ? (
                <div>
                    {label}
                    <span style={{ fontSize: "14px", }}>*</span>
                </div>
            ) : (label)}
        </Typography>
    }

    if (!(answerLabel && answerValue)) return null;

    return (
        <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
            {props.group !== "eligibility" && (
                <div className={styles.summaryValue}>
                    {showRequiredInLabel(answerLabel) || ""}
                    <Typography variant="subtitle1" gutterBottom>
                        {answerValue || ""}
                    </Typography>
                </div>
            )}
            {props.group === "eligibility" && (
                <ul>
                    <li className={styles.bullet}>
                        <div className={styles.summaryValue}>
                            {showRequiredInLabel(props.label) || ""}
                            <Typography variant="h5" gutterBottom>
                                {answerValue || ""}
                            </Typography>
                        </div>
                    </li>
                </ul>
            )}
        </Grid>
    );
}
